import { render, staticRenderFns } from "./PageExpired.vue?vue&type=template&id=4acfc61e&scoped=true&"
import script from "./PageExpired.vue?vue&type=script&lang=js&"
export * from "./PageExpired.vue?vue&type=script&lang=js&"
import style0 from "./PageExpired.vue?vue&type=style&index=0&id=4acfc61e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acfc61e",
  null
  
)

export default component.exports